// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__AsyncButtonLink__asyncButtonLink{min-width:var(--GW-ASYNC-BUTTON-LINK-MIN-WIDTH)}", "",{"version":3,"sources":["webpack://./../../../src/internal/AsyncButtonLink/AsyncButtonLink.module.scss","webpack://./../../platform/@jutro/router/internal/AsyncButtonLink/AsyncButtonLink.module.css"],"names":[],"mappings":"AAAA,uCACE,+CCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"asyncButtonLink": "jut__AsyncButtonLink__asyncButtonLink"
};
export default ___CSS_LOADER_EXPORT___;
